(function () {
  var track = (function createStorefrontTracker({ window, productHandles = [] }) {
  const products = new Set(productHandles);
  const families = new Set(['all', 'tea', 'heritage', 'wellness', 'everyday', 'instant', 'gifts', 'coming-soon']);
  const pages = new Set(['community', 'compare', 'contact', 'faq', 'our-house', 'start-here', 'tea-and-ritual', 'service', 'stories', 'privacy-policy', 'terms-of-service']);
  const names = new Set(['navigation_open', 'compare_filter', 'faq_open', 'upcoming_notify_intent', 'view_item', 'add_to_cart', 'remove_from_cart', 'view_item_list', 'view_cart', 'checkout_intent', 'select_item', 'newsletter_signup_intent', 'testimonial_start', 'testimonial_complete', 'story_audio_start', 'story_audio_complete', 'variant_select', 'product_impression', 'cta_select', 'finder_complete', 'finder_select', 'search_submit', 'search_result_select', 'search_no_results', 'native_form_success', 'whatsapp_draft_open', 'email_draft_open', 'further_reading_open', 'cart_error', 'checkout_handoff_error']);
  function publicPath(pathname) {
    const parts = typeof pathname === 'string' ? pathname.split('/').filter(Boolean) : [];
    if (!parts.length) return '/';
    if (parts.length === 1 && ['search', 'cart'].includes(parts[0])) return '/' + parts[0];
    if (parts.length === 2 && ((parts[0] === 'products' && products.has(parts[1])) || (parts[0] === 'collections' && families.has(parts[1])) || (parts[0] === 'pages' && pages.has(parts[1])))) return '/' + parts.join('/');
    if (parts[0] === 'blogs' && ['articles', 'stories'].includes(parts[1])) return '/blogs/' + parts[1];
    return '/other';
  }
  return function track(name, data = {}) {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || typeof privacy?.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed() !== true || !names.has(name)) return false;
      const input = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
      const payload = { event: name, page_path: publicPath(window.location?.pathname) };
      if (input.preview === true) payload.preview = true;
      const numeric = (key, max, integer = false) => {
        const value = input[key];
        if (typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= max && (!integer || Number.isInteger(value))) payload[key] = value;
      };
      const itemEvents = ['view_item', 'add_to_cart', 'remove_from_cart', 'select_item', 'upcoming_notify_intent', 'variant_select', 'product_impression', 'finder_complete', 'finder_select'];
      if (itemEvents.includes(name)) {
        let id = input.item_id;
        if (name === 'select_item' && typeof input.destination === 'string') {
          const match = input.destination.match(/^\/products\/([a-z0-9-]+)\/?$/);
          if (match) id = match[1];
        }
        if (!products.has(id)) return false;
        payload.item_id = id;
        if (name === 'upcoming_notify_intent') payload.channel = 'whatsapp';
        if (name === 'view_item' && ['available', 'upcoming'].includes(input.availability)) payload.availability = input.availability;
        if (['view_item', 'add_to_cart', 'remove_from_cart'].includes(name)) {
          numeric('price', 100000);
          if (input.currency === 'INR') payload.currency = 'INR';
        }
        if (['add_to_cart', 'remove_from_cart'].includes(name)) numeric('quantity', 10000, true);
      }
      if (name === 'navigation_open' && ['mobile', 'shop', 'search'].includes(input.navigation_name)) payload.navigation_name = input.navigation_name;
      if (name === 'compare_filter') {
        const family = typeof input.filter_name === 'string' ? input.filter_name.toLowerCase() : '';
        if (families.has(family) || ['any','none','low','medium'].includes(family)) payload.filter_name = family;
        numeric('visible_items', products.size, true);
      }
      if (name === 'view_item_list') numeric('item_count', products.size, true);
      if (['view_cart', 'checkout_intent'].includes(name)) {
        numeric('cart_value', 1000000);
        if (input.currency === 'INR') payload.currency = 'INR';
      }
      // These are allowlisted in-memory events, not a pixel installation or a consent-setting API.
      const layer = window.dataLayer;
      if (layer !== undefined && !Array.isArray(layer)) return false;
      const safe = Object.freeze(payload);
      if (layer === undefined) window.dataLayer = [];
      window.dataLayer.push(safe);
      if (typeof window.CustomEvent === 'function' && typeof window.dispatchEvent === 'function') window.dispatchEvent(new window.CustomEvent('kehwah:analytics', { detail: safe }));
      return true;
    } catch {
      return false;
    }
  };
})({window:window,productHandles:(() => {
  let catalogue = [];
  try { catalogue = JSON.parse(document.querySelector('[data-ks-catalogue-handles]')?.textContent || '[]'); } catch (_) {}
  return [...(Array.isArray(catalogue) ? catalogue : []), ...Array.from(document.querySelectorAll('[data-handle],[data-product-handle]'),node=>node.dataset.handle||node.dataset.productHandle)].filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle));
})()});
  window.kehwahTrack = track;
  function toast(message) {
    var element = document.querySelector('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    window.clearTimeout(window.__kehwahToast);
    window.__kehwahToast = window.setTimeout(function () { element.classList.remove('is-visible'); }, 2600);
  }
  var productCartMessages = {"adding":"Adding…","added":"Added to your bag.","review":"View bag & checkout","review_first":"Review bag first","uncertain":"Your cup may already be in the bag. Please check it before adding more.","stock":"Availability changed while you were choosing. Please check your bag before adding more.","refresh_failed":"Your cup was added. Please open your bag to see the latest selection.","checkout_loading":"Secure checkout is still loading. Please try again in a moment.","checkout_review":"Your tea is in the bag. Please review your bag before checking out.","checkout_opening":"Opening secure checkout…","invalid":"Please choose an available pack and a whole-number quantity of at least one."};
  var messageSource = document.querySelector('[data-product-cart-messages]');
  if (messageSource) Object.keys(productCartMessages).forEach(function (key) { var value = messageSource.getAttribute('data-' + key); if (value) productCartMessages[key] = value; });
  (function installProductCart({ document, window, fetch, FormData, messages, track, timeoutMs = 15000 }) {
  if (window.kehwahProductCart) {
    window.kehwahProductCart.sync();
    return window.kehwahProductCart;
  }
  const state = { busy: false, review: false, navigating: false, message: '', sourceForm: null, generation: 0, read: 0 };
  const originals = new WeakMap();
  const selector = '[data-august-product-form]';
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function sync() {
    document.querySelectorAll(selector).forEach(form => {
      form.querySelectorAll('button[type="submit"]').forEach(button => {
        const label = button.querySelector?.('[data-product-action-label]') || button;
        if (!originals.has(button)) originals.set(button, { disabled: button.disabled, text: label.textContent });
        const original = originals.get(button);
        if (button.hasAttribute('data-product-buy-now')) button.hidden = false;
        button.disabled = original.disabled || state.busy || state.review;
        button.setAttribute('aria-disabled', String(button.disabled));
        label.textContent = original.disabled ? original.text : state.busy ? messages.adding : state.review ? messages.review_first : original.text;
      });
      form.setAttribute('aria-busy', String(state.busy));
      const feedback = form.querySelector('[data-product-cart-feedback]');
      const status = form.querySelector('[data-product-cart-status]');
      if (feedback && status) {
        feedback.hidden = !state.message || (state.sourceForm && form !== state.sourceForm);
        status.textContent = state.message;
      }
    });
    document.dispatchEvent(new CustomEvent('kehwah:cart-state', { detail: { busy: state.busy, review: state.review } }));
  }
  function setAvailability(form, available) {
    form.querySelectorAll('button[type="submit"]').forEach(button => {
      const buyNow = button.hasAttribute('data-product-buy-now');
      originals.set(button, { disabled: !available, text: available ? (buyNow ? 'Buy now' : 'Add to bag') : 'Currently unavailable' });
    });
    sync();
  }
  async function request(url, options = {}) {
    const controller = new window.AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const value = await response.json();
      return { response, value };
    } finally { window.clearTimeout(timer); }
  }
  async function refresh() {
    const generation = state.generation;
    const read = ++state.read;
    try {
      const { response, value } = await request(root() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok || generation !== state.generation || read !== state.read || !Array.isArray(value.items) || !Number.isSafeInteger(value.item_count) || value.item_count < 0) return null;
      document.querySelectorAll('[data-bag-count]').forEach(node => { node.textContent = String(value.item_count); });
      return value;
    } catch { return null; }
  }
  async function submit(event) {
    const form = event.target;
    if (!form || !form.matches(selector)) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (!button || button.disabled || state.busy || state.review) return;
    state.sourceForm = form;
    const reviewBag = form.hasAttribute('data-product-review-bag') || button.hasAttribute('data-product-buy-now');
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    const quantity = Number(data.get('quantity'));
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) {
      state.message = messages.invalid;
      sync();
      return;
    }
    sync();
    state.busy = true;
    state.message = '';
    state.generation += 1;
    sync();
    let confirmed = false;
    let confirmedLine;
    try {
      const added = await request(root() + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data,
      });
      const result = added.value;
      const lines = Array.isArray(result.items) ? result.items : [result];
      confirmedLine = lines.find(line => String(line.variant_id || line.id) === id && Number.isSafeInteger(line.quantity) && line.quantity >= quantity);
      confirmed = added.response.ok && Boolean(confirmedLine);
      state.review = !confirmed;
      state.message = confirmed ? `${quantity} × ${button.dataset.title || confirmedLine.product_title || 'Selected pack'} added to your bag.` : added.response.status === 422 ? messages.stock : messages.uncertain;
    } catch {
      state.review = true;
      state.message = messages.uncertain;
    }
    const cart = await refresh();
    const selectedLineInCart = cart?.items.some(item => String(item.variant_id || item.id) === id && item.quantity >= quantity);
    if (reviewBag && confirmed && cart && !selectedLineInCart) {
      state.review = true;
      state.message = messages.checkout_review;
    }
    if (confirmed && !cart) {
      state.review = true;
      state.message = messages.refresh_failed;
    }
    state.busy = false;
    sync();
    if (!confirmed) track?.('cart_error');
    if (confirmed && typeof track === 'function') {
      try { track('add_to_cart', { item_id: button.dataset.handle || id, item_name: button.dataset.title, price: Number.isFinite(confirmedLine.final_price) ? confirmedLine.final_price / 100 : Number(button.dataset.price || 0), currency: cart?.currency || 'INR', quantity }); } catch {}
    }
    if (reviewBag && confirmed && cart && !state.review) {
      state.busy = true;
      state.navigating = true;
      sync();
      try {
        window.location.assign(root() + 'cart');
      } catch {
        state.busy = false;
        state.navigating = false;
        state.review = true;
        state.message = messages.checkout_review;
        sync();
      }
    }

  }
  function beginExternal() {
    if (state.busy || state.review) return false;
    state.busy = true; state.message = ''; state.sourceForm = null; state.generation += 1; sync(); return true;
  }
  function finishExternal(review = false) {
    state.busy = false; state.review = review; state.message = ''; sync();
  }
  const api = { sync, refresh, setAvailability, beginExternal, finishExternal, get blocked() { return state.busy || state.review; } };
  window.kehwahProductCart = api;
  document.addEventListener('submit', submit);
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', event => {
    if (event.persisted && state.navigating) {
      state.navigating = false;
      state.busy = false;
      state.message = '';
      sync();
      refresh();
    }
  });
  sync();
  refresh();
  return api;
})({ document: document, window: window, fetch: window.fetch.bind(window), FormData: FormData, messages: productCartMessages, track: track });
  (function installStorefrontNavigation({ document, window, track = () => {} }) {
  if (document.documentElement.dataset.navigationBound === 'true') return;
  document.documentElement.dataset.navigationBound = 'true';
  const desktopQuery = window.matchMedia('(min-width: 1021px)');
  const megaSelector = '.site-mega, .editor-mega';
  const pairs = () => Array.from(document.querySelectorAll('[data-menu-button]')).map(button => ({
    button, menu: document.getElementById(button.getAttribute('aria-controls')),
  })).filter(pair => pair.menu?.matches('[data-mobile-menu]'));
  const menus = () => Array.from(document.querySelectorAll(megaSelector));
  const links = menu => Array.from(menu.querySelectorAll('a[href], summary')).filter(link => !link.closest('details:not([open])') || link.matches('summary'));
  function mobileState({ button, menu }, open, restore = false) {
    if (restore && menu.contains(document.activeElement)) button.focus();
    menu.hidden = !open;
    menu.inert = !open;
    menu.setAttribute('aria-hidden', String(!open));
    menu.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open));
    const label = button.querySelector('.sr-only');
    if (label) label.textContent = button.getAttribute(open ? 'data-menu-close-label' : 'data-menu-open-label') || (open ? 'Close menu' : 'Open menu');
  }
  function closeMega(menu, restore = false) {
    const focused = menu.contains(document.activeElement);
    menu.open = false;
    if (restore && focused) menu.querySelector('summary')?.focus();
  }
  function initialize(root = document) {
    pairs().filter(({ button }) => root.contains(button)).forEach(pair => mobileState(pair, false));
  }
  function dismissOutside(target) {
    pairs().forEach(pair => {
      if (pair.button.getAttribute('aria-expanded') === 'true' && !pair.menu.contains(target) && !pair.button.contains(target)) mobileState(pair, false);
    });
    menus().forEach(menu => { if (menu.open && !menu.contains(target)) closeMega(menu); });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-menu-button]');
    const pair = pairs().find(pair => pair.button === button);
    if (pair && !desktopQuery.matches) {
      const open = button.getAttribute('aria-expanded') !== 'true';
      dismissOutside(button);
      mobileState(pair, open);
      if (open) track('navigation_open', { navigation_name: 'mobile' });
      return;
    }
    const link = event.target.closest('a[href]');
    if (link) {
      pairs().forEach(pair => { if (pair.menu.contains(link)) mobileState(pair, false); });
      menus().forEach(menu => { if (menu.contains(link)) closeMega(menu); });
    }
    dismissOutside(event.target);
  });
  document.addEventListener('focusin', event => dismissOutside(event.target));
  document.addEventListener('keydown', event => {
    const pair = pairs().find(pair => pair.button.getAttribute('aria-expanded') === 'true' && (pair.button.contains(event.target) || pair.menu.contains(event.target)));
    if (event.key === 'Escape') {
      if (pair) { event.preventDefault(); mobileState(pair, false, true); }
      const mega = event.target.closest(megaSelector);
      if (mega?.open) { event.preventDefault(); closeMega(mega, true); }
      return;
    }
    if (!pair) return;
    const items = links(pair.menu);
    if (!items.length) return;
    if ((event.key === 'Tab' && !event.shiftKey || event.key === 'ArrowDown') && event.target === pair.button) {
      event.preventDefault(); items[0].focus();
    } else if (event.key === 'Tab' && event.shiftKey && event.target === items[0]) {
      event.preventDefault(); pair.button.focus();
    }
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches(megaSelector) || !event.target.open) return;
    menus().forEach(menu => { if (menu !== event.target && menu.open) closeMega(menu); });
    track('navigation_open', { navigation_name: 'shop' });
  }, true);
  desktopQuery.addEventListener('change', () => {
    const active = document.activeElement;
    const activeMobile = pairs().find(pair => pair.menu.contains(active));
    const activeMega = menus().find(menu => menu.contains(active));
    pairs().forEach(pair => mobileState(pair, false));
    menus().forEach(menu => closeMega(menu));
    if (desktopQuery.matches && activeMobile) document.querySelector('.primary-nav summary, .primary-nav a')?.focus();
    else if (!desktopQuery.matches && activeMega) pairs()[0]?.button.focus();
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', () => { initialize(); menus().forEach(menu => closeMega(menu)); });
  initialize();
})({document:document,window:window,track:track});
  (function installUpcomingNotify({ document, window, track = () => {}, preview = false }) {
  if (document.documentElement.dataset.upcomingNotifyBound === 'true') return;
  document.documentElement.dataset.upcomingNotifyBound = 'true';
  function bind(root) {
    const forms = [...(root.matches?.('[data-upcoming-notify]') ? [root] : []), ...root.querySelectorAll('[data-upcoming-notify]')];
    forms.forEach(form => {
      if (form.dataset.notifyBound === 'true') return;
      form.dataset.notifyBound = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const nameInput = form.querySelector('[name="first_name"]');
        const phoneInput = form.querySelector('[name="whatsapp_number"]');
        const consentInput = form.querySelector('[name="consent"]');
        const status = form.querySelector('[data-notify-status]');
        const fields = [nameInput, phoneInput, consentInput].filter(Boolean);
        fields.forEach(field => field.removeAttribute('aria-invalid'));
        if (status && !status.id) status.id = form.id + '-status';
        function announce(message, field) {
          if (status) status.textContent = message;
          if (field) {
            field.setAttribute('aria-invalid', 'true');
            if (status) {
              const descriptions = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
              descriptions.add(status.id);
              field.setAttribute('aria-describedby', [...descriptions].join(' '));
            }
            field.focus();
          }
        }
        const firstName = (nameInput?.value || '').trim();
        const enteredPhone = (phoneInput?.value || '').trim().replace(/[\s().-]/g, '');
        const destination = (form.dataset.whatsappNumber || '').trim().replace(/[\s()+.-]/g, '');
        if (firstName.length < 2) { announce('Please add your first name.', nameInput); return; }
        if (!/^\+?[1-9][0-9]{7,14}$/.test(enteredPhone)) { announce('Please add a valid WhatsApp number, including your country code.', phoneInput); return; }
        if (!consentInput?.checked) { announce('Please confirm that Kehwah may send launch updates for this tea on WhatsApp.', consentInput); return; }
        if (!/^[1-9][0-9]{7,14}$/.test(destination)) { announce('Kehwah’s WhatsApp number still needs to be configured.'); return; }
        const title = form.dataset.productTitle || 'this tea';
        const message = 'Hello Kehwah, I’d love to know when ' + title + ' joins the house. I’m ' + firstName + ', and I agree to receive launch updates for this tea on WhatsApp. My preferred WhatsApp number is ' + enteredPhone + '.';
        const metadata = { item_id: form.dataset.productHandle || '', item_name: title, channel: 'whatsapp' };
        if (preview) metadata.preview = true;
        // Analytics must not stop a customer's handoff if an optional tracker is unavailable.
        try { track('upcoming_notify_intent', metadata); } catch {}
        announce('Opening your launch note in WhatsApp…');
        try { window.location.assign('https://wa.me/' + destination + '?text=' + encodeURIComponent(message)); }
        catch { announce('WhatsApp could not open. Please try again. Your note has not been sent.'); }
      });
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})({ document: document, window: window, track: track });
  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function syncAmbientMotion() {
    document.querySelectorAll('[data-ambient-video]').forEach(function (video) {
      var reveal = function () { video.classList.add('is-ready'); };
      if (video.readyState >= 2) reveal(); else video.addEventListener('loadeddata', reveal, { once: true });
      if (motionQuery && motionQuery.matches) { video.pause(); video.removeAttribute('autoplay'); video.classList.remove('is-ready'); }
      else { video.setAttribute('autoplay', ''); var playback = video.play(); if (playback && playback.catch) playback.catch(function () {}); }
    });
  }
  if (motionQuery && motionQuery.addEventListener) motionQuery.addEventListener('change', syncAmbientMotion);
  syncAmbientMotion();
  function initGallery(root) {
    if (root.dataset.galleryReady === 'true') return;
    var viewport = root.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var previous = root.querySelector('[data-gallery-previous]');
    var next = root.querySelector('[data-gallery-next]');
    var indexLabel = root.querySelector('[data-gallery-index]');
    var status = root.querySelector('[data-gallery-status]');
    var active = 0;
    var programmaticTarget = null;
    var settleTimer = 0;
    var ticking = false;
    if (!viewport || !slides.length) return;
    root.dataset.galleryReady = 'true';
    function setActive(index, announce) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      var changed = index !== active; active = index;
      thumbs.forEach(function (thumb, thumbIndex) { var selected = thumbIndex === active; thumb.classList.toggle('is-active', selected); thumb.setAttribute('aria-current', String(selected)); });
      if (previous) previous.disabled = active === 0; if (next) next.disabled = active === slides.length - 1;
      if (indexLabel) indexLabel.textContent = String(active + 1).padStart(2, '0');
      if (status && announce && changed) status.textContent = 'Image ' + (active + 1) + ' of ' + slides.length + ': ' + (slides[active].dataset.galleryLabel || 'Product image');
    }
    function destination(index) { return slides[index].offsetLeft - slides[0].offsetLeft; }
    function releaseProgrammaticTarget() { programmaticTarget = null; window.clearTimeout(settleTimer); }
    function goTo(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      programmaticTarget = index; window.clearTimeout(settleTimer); setActive(index, true);
      viewport.scrollTo({ left: destination(index), behavior: motionQuery && motionQuery.matches ? 'auto' : 'smooth' });
      settleTimer = window.setTimeout(function () { releaseProgrammaticTarget(); setActive(Math.round(viewport.scrollLeft / (viewport.clientWidth || 1)), true); }, 700);
    }
    if (previous) previous.addEventListener('click', function () { goTo(active - 1); });
    if (next) next.addEventListener('click', function () { goTo(active + 1); });
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { goTo(index); });
      thumb.addEventListener('keydown', function (event) {
        var target = event.key === 'ArrowRight' ? index + 1 : event.key === 'ArrowLeft' ? index - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : null;
        if (target === null) return;
        event.preventDefault(); target = Math.max(0, Math.min(target, thumbs.length - 1)); thumbs[target].focus(); goTo(target);
      });
    });
    viewport.addEventListener('keydown', function (event) {
      var index = event.key === 'ArrowRight' ? active + 1 : event.key === 'ArrowLeft' ? active - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : null;
      if (index === null) return;
      event.preventDefault(); goTo(index);
    });
    viewport.addEventListener('pointerdown', releaseProgrammaticTarget, { passive: true });
    viewport.addEventListener('wheel', releaseProgrammaticTarget, { passive: true });
    viewport.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () {
        if (programmaticTarget !== null) {
          if (Math.abs(viewport.scrollLeft - destination(programmaticTarget)) < 2) {
            var target = programmaticTarget; releaseProgrammaticTarget(); setActive(target, false);
          }
        } else setActive(Math.round(viewport.scrollLeft / (viewport.clientWidth || 1)), true);
        ticking = false;
      });
    }, { passive: true });
    function resizeGallery() {
      if (!root.isConnected) { window.removeEventListener('resize', resizeGallery); return; }
      releaseProgrammaticTarget(); viewport.scrollTo({ left: destination(active), behavior: 'instant' });
    }
    window.addEventListener('resize', resizeGallery);
    setActive(0, false);
  }
  document.querySelectorAll('[data-gallery]').forEach(initGallery);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-gallery]').forEach(initGallery);
  });
  document.querySelectorAll('.proof-rail-controls').forEach(function (controls) {
    var section = controls.closest('section'); var rail = section && section.querySelector('[data-proof-rail]'); if (!rail) return;
    var previous = controls.querySelector('[data-proof-previous]'); var next = controls.querySelector('[data-proof-next]');
    function move(direction) { var card = rail.querySelector('.customer-proof-card'); var distance = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth; rail.scrollBy({ left: direction * distance, behavior: motionQuery && motionQuery.matches ? 'auto' : 'smooth' }); }
    if (previous) previous.addEventListener('click', function () { move(-1); }); if (next) next.addEventListener('click', function () { move(1); });
  });
  var compareButtons = Array.prototype.slice.call(document.querySelectorAll('[data-compare-button]'));
  var compareProducts = Array.prototype.slice.call(document.querySelectorAll('[data-compare-product]'));
  var compareEmpty = document.querySelector('[data-compare-empty]'); var compareStatus = document.querySelector('[data-compare-status]');
  compareButtons.forEach(function (button) { button.addEventListener('click', function () { var filter = button.dataset.compareButton; var visible = 0; compareButtons.forEach(function (candidate) { var on = candidate === button; candidate.classList.toggle('is-active', on); candidate.setAttribute('aria-pressed', String(on)); }); compareProducts.forEach(function (product) { var show = filter === 'upcoming' ? product.dataset.compareUpcoming === 'true' : product.dataset.compareUpcoming !== 'true' && (filter === 'all' || product.dataset.compareFilter === filter); product.hidden = !show; if (show) visible += 1; }); if (compareEmpty) compareEmpty.hidden = visible !== 0; if (compareStatus) compareStatus.textContent = 'Showing ' + visible + (visible === 1 ? ' cup.' : ' cups.'); track('compare_filter', { filter_name: filter, visible_items: visible }); }); });
  document.querySelectorAll('details:not([data-ks-reading])').forEach(function (details) { details.addEventListener('toggle', function () { if (details.open) { var summary = details.querySelector('summary'); track('faq_open', { question: summary ? summary.textContent.trim().slice(0, 140) : 'FAQ' }); } }); });
  var stickyBuy = document.querySelector('[data-sticky-buy]'); var primaryBuy = document.querySelector('[data-primary-add-to-bag]'); var footer = document.querySelector('.site-footer');
  if (stickyBuy && primaryBuy) { function syncStickyBuy() { var primaryRect = primaryBuy.getBoundingClientRect(); var footerRect = footer ? footer.getBoundingClientRect() : { top: Infinity }; var show = (primaryRect.bottom < 0 || primaryRect.top > window.innerHeight) && footerRect.top > window.innerHeight; stickyBuy.classList.toggle('is-visible', show); stickyBuy.setAttribute('aria-hidden', String(!show)); stickyBuy.inert = !show; document.body.classList.toggle('has-sticky-buy', show); } window.addEventListener('scroll', function () { window.requestAnimationFrame(syncStickyBuy); }, { passive: true }); window.addEventListener('resize', syncStickyBuy); syncStickyBuy(); }
  var availableProduct = document.body.classList.contains('template-product') ? document.querySelector('[data-ks-primary],[data-primary-add-to-bag]') : null;
  if (availableProduct) track('view_item', { item_id: availableProduct.dataset.handle, item_name: availableProduct.dataset.title, price: Number(availableProduct.dataset.price), currency: 'INR', availability: 'available' });
  var upcomingProduct = document.querySelector('[data-upcoming-notify]');
  if (upcomingProduct) track('view_item', { item_id: upcomingProduct.dataset.productHandle, item_name: upcomingProduct.dataset.productTitle, availability: 'upcoming' });
})();

(() => {
  function enhance(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.zoomReady) return;
      gallery.dataset.zoomReady = 'true';
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      if (!slides.length) return;
      const toolbar = gallery.querySelector('.pdp-gallery-toolbar') || gallery;
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'gallery-zoom'; trigger.textContent = 'View closer';
      trigger.setAttribute('aria-haspopup', 'dialog');
      toolbar.insertBefore(trigger, toolbar.querySelector('.pdp-gallery-arrows'));
      let dialog, active = 0;
      const show = () => {
        if (!dialog) {
          dialog = document.createElement('dialog'); dialog.className = 'gallery-lightbox';
          dialog.setAttribute('aria-label', 'Product image viewer');
          dialog.setAttribute('aria-modal', 'true');
          const element = (tag, attributes, text = '') => {
            const node = document.createElement(tag);
            for (const [name, value] of Object.entries(attributes)) node.setAttribute(name, value);
            node.textContent = text;
            return node;
          };
          const header = element('div', { class: 'gallery-lightbox-header' });
          header.append(
            element('p', { 'data-viewer-title': '' }),
            element('button', { type: 'button', 'data-viewer-close': '', 'aria-label': 'Close image viewer' }, 'Close ×')
          );
          const controls = element('div', { class: 'gallery-lightbox-controls' });
          controls.append(
            element('button', { type: 'button', 'data-viewer-prev': '', 'aria-label': 'Previous enlarged image' }, '←'),
            element('button', { type: 'button', 'data-viewer-next': '', 'aria-label': 'Next enlarged image' }, '→')
          );
          const footer = element('div', { class: 'gallery-lightbox-footer' });
          footer.append(element('p', { 'data-viewer-caption': '', 'aria-live': 'polite' }), controls);
          dialog.append(header, element('img', { class: 'gallery-lightbox-image', alt: '' }), footer);
          gallery.append(dialog);
          dialog.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
          dialog.querySelector('[data-viewer-prev]').addEventListener('click', () => render(active - 1));
          dialog.querySelector('[data-viewer-next]').addEventListener('click', () => render(active + 1));
          dialog.addEventListener('keydown', event => {
            if (event.key === 'Tab') {
              const controls = [...dialog.querySelectorAll('button:not([disabled])')];
              const first = controls[0], last = controls[controls.length - 1];
              const focused = document.activeElement;
              if (first && ((event.shiftKey && (focused === first || !dialog.contains(focused))) ||
                (!event.shiftKey && (focused === last || !dialog.contains(focused))))) {
                event.preventDefault();
                (event.shiftKey ? last : first).focus({ preventScroll: true });
              }
              return;
            }
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault(); render(active + (event.key === 'ArrowLeft' ? -1 : 1));
            }
          });
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          });
          dialog.addEventListener('close', () => {
            if (trigger.isConnected) trigger.focus({ preventScroll: true });
          });
        }
        const thumb = gallery.querySelector('[data-gallery-thumb][aria-current="true"]');
        render(Number(thumb?.dataset.galleryThumb || 0));
        if (!dialog.open) {
          dialog.showModal();
          dialog.querySelector('[data-viewer-close]').focus({ preventScroll: true });
        }
      };
      const render = index => {
        active = Math.max(0, Math.min(slides.length - 1, index));
        const source = slides[active].querySelector('img');
        if (!source) return;
        const image = dialog.querySelector('img');
        image.src = source.currentSrc || source.src; image.alt = source.alt;
        dialog.querySelector('[data-viewer-title]').textContent = slides[active].dataset.galleryLabel || 'Product photo';
        dialog.querySelector('[data-viewer-caption]').textContent = `${active + 1} / ${slides.length} · ${slides[active].querySelector('figcaption')?.textContent.trim() || source.alt}`;
        const previous = dialog.querySelector('[data-viewer-prev]');
        const next = dialog.querySelector('[data-viewer-next]');
        const focused = document.activeElement;
        previous.disabled = active === 0;
        next.disabled = active === slides.length - 1;
        if (dialog.open && ((focused === previous && previous.disabled) || (focused === next && next.disabled))) {
          const target = focused === next ? previous : next;
          (target.disabled ? dialog.querySelector('[data-viewer-close]') : target).focus({ preventScroll: true });
        }
      };
      trigger.addEventListener('click', show);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
